import { render, staticRenderFns } from "./ManageLocaleString.vue?vue&type=template&id=69e22203&"
import script from "./ManageLocaleString.vue?vue&type=script&lang=js&"
export * from "./ManageLocaleString.vue?vue&type=script&lang=js&"
import style0 from "./ManageLocaleString.vue?vue&type=style&index=0&id=69e22203&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports